export default {
	position: "relative",
	borderRadius: "15px",
	width: "100%",
	height: "100%",
	maxHeight: "100%",
	overflow: "hidden",
}
